import script from "./DocumentSkeletonCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentSkeletonCard.vue?vue&type=script&setup=true&lang=js"

import "./DocumentSkeletonCard.vue?vue&type=style&index=0&id=ed38ed62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed38ed62"]])

export default __exports__